// Translations
import form from '../sections/form/translations/tr'

// Translation: Password change > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
